// This is the entry component for Admin page.

<template>
  <div>
    <nav  class="navbar navbar-expand-lg navbar-light container-fluid navbar-admin bg-success text-white">
      <span class="navbar-brand mb-0 h2" href="#">
        <!--<img src="../assets/img/Emblem_of_Taipei_City.svg.png" class="navbar-brand" alt="taipei-city-logo" height="45px">-->
        <img src="../assets/img/changhua.png" class="navbar-brand" alt="changhua-logo" height="60px">
        <!--<img src="../assets/img/Republic_of_China_Police_Logo.svg.png" alt="autoix-logo" height="45px" class="navbar-brand">-->
      </span>
      <button class="btn btn-primary" @click="home">首頁</button>
      &nbsp;&nbsp;
      <span  id="greeting" v-if="user !== null || user !== undefined">{{ GreetingMsg }}, 
        <span v-if="user.first_name !== null && user.last_name !== null">{{user.last_name}}{{ user.first_name }}</span>
        <span v-else>{{ user.username }}</span>
        <span v-if="user.title  !== null">{{ user.title.name }}</span>
      </span>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" style="margin-left: auto; margin-right: 1rem;">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item dropdown" v-for="nav in navs" v-if="Object.keys(nav.child).length > 0">
            <div class="nav-link dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-if="nav.privilege">
              {{ nav.name }}
            </div>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link class="dropdown-item" :to="{ name: child.url }" v-for="child in nav.child" :key="child.name" v-if="child.privilege">{{ child.name }}</router-link>
            </div>
          </li>
          <li class="nav-item" v-else>
            <router-link :to="{ name: nav.url }" class="nav-link" v-if="nav.privilege">
              {{ nav.name }}
            </router-link>
          </li>
        </ul>
      </div>
      <button class="btn btn-danger" @click="logout">登出</button>
    </nav>
    <div class="container-fluid main-container">
      <locked-mask v-show="pageShouldChecked && frontendLogined"></locked-mask>
      <div v-if="$route.name === 'Admin'" :class="{ 'admin-hero': true, 'admin-blur': (pageShouldChecked && frontendLogined) }">
          <h1 class="display-4">歡迎使用</h1>
          <h1 class="display-4 bg-info text-white rounded">彰化台61科技執法後台管理系統</h1>
          <div v-if="department=='Admin'">
          <!--<div v-if="department=='Admin' || department=='xx市政府警察局交通警察大隊'">-->
            <h3> <kbd>查詢地點選擇 </kbd></h3>
              <div class="custom-control custom-radio">
                <input v-model="fixedLinkCode4SuperUser" type="radio" class="custom-control-input" id="defaultGroupExample1" value="B01">
                <label class="custom-control-label" for="defaultGroupExample1"><h5>台61彰化段(北上)</h5></label>
              </div>
              <!--<div class="custom-control custom-radio">
                <input v-model="fixedLinkCode4SuperUser" type="radio" class="custom-control-input" id="defaultGroupExample2" value="B03">
                <label class="custom-control-label" for="defaultGroupExample2"><h5>台61彰化段(南下)</h5></label>
              </div>-->
          </div>
      </div>
      <div :class="{ 'admin-blur': (pageShouldChecked && frontendLogined) }">
        <router-view/>
      </div>
    </div>
    <div class="container-fluid main-footer bg-warning text-dark">
      <p>
        <small class="font-weight-bold">Copyright © EST</small>
        <small class="float-right font-weight-bold">version:{{ version }}</small>
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
//import $ from 'jquery';
import Popper from 'popper.js';
import { version, webSocketServer, systemType } from '@/config';
import LockedMask from './Admin/LockedMask';

window.$ = $;
window.Popper = Popper;

require('bootstrap');

export default {
  name: 'Admin',
  data() {
    return {
      version,
      systemType,
      socket: null,
      pageShouldChecked: false,
      fixedLinkCode4SuperUser: 'B01',
      fixedLinkCodeObj: [],
      department: this.$store.state.user.user.department.name,
      //reportExportPrivilege: false,
    };
  },
  components: {
    LockedMask,
  },
  methods: {
    getFixedLinkCode() {
      return this.instance.get('/api/fixed-link-code/')
      .then((res) => {
        res.data.forEach((data) => {
          this.fixedLinkCodeObj[data.fixed_link_code]=data.id;
          });
      });
    },
    logout() {
      this.$store.dispatch('logout');
      this.$router.push({ name: 'AdminLogin' });
    },
    home() {
      this.$router.push({ name: 'Admin' });
    },
    checkFrontendUserLogined() {
      this.instance.get('/api/user/', {
        params: {
          online: true,
        },
      })
      .then((res) => {
        this.$store.commit('FRONETEND_PANEL_USER_LOGINED', res.data.results);
      });
    },
    checkedPath(route) {
      if (route.path.split('/').includes('report-export')) {
        this.pageShouldChecked = false;
      } else {
        this.pageShouldChecked = true;
      }
    },
    eventNotification() {
      this.socket = new WebSocket(`${webSocketServer}/update-drug-storage-signal/`);
      this.socket.onopen = (e) => {
        this.socket.send(JSON.stringify({ message: 'connected' }));
      };
      this.socket.onmessage = (e) => {
        if (JSON.parse(e.data).message) {
          //const msg = JSON.parse(JSON.parse(e.data).message);
          const msg = JSON.parse(e.data).message;
          console.log(msg);
          if (msg.command === 'drug_storage_updated') {
            this.$store.commit('DRUG_STORAGE_EVENT_FIRED', msg.id);
          }
        }
      };
    },
  },
  async created() {
    await this.getFixedLinkCode();
    if(this.department=='Admin')// || this.department=='xx市政府警察局交通警察大隊')
    {
      //this.reportExportPrivilege = true;
      console.log('departname:',this.department);
      //await this.getFixedLinkCode();
      this.$store.state.user.user.department.fixed_link_code = this.fixedLinkCodeObj[this.fixedLinkCode4SuperUser];
      /*
      if(this.$store.state.user.user.username=='B01User') {
        this.$store.state.user.user.department.fixed_link_code = this.fixedLinkCodeObj['B01'];
      }
      if(this.$store.state.user.user.username=='B03User') {
        this.$store.state.user.user.department.fixed_link_code = this.fixedLinkCodeObj['B03']; 
      }
      */
    }
    //else
    //  this.reportExportPrivilege = false;
    this.$store.commit('CREATE_INSTANCE');
    if (this.$store.state.webSocket !== null) {
      this.$store.state.webSocket.close();
    }
    //this.eventNotification();
    this.checkedPath(this.$route);
    console.log('systems',this.$store.state.device.systems);
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    GreetingMsg() {
      const hourNow = moment().hour();
      if (hourNow >= 5 && hourNow < 11) {
        return '早安';
      }
      if (hourNow >= 11 && hourNow <= 17) {
        return '午安';
      }
      return '晚安';
    },
    frontendLogined() {
      return this.$store.getters.frontendLogined;
    },
    route() {
      return this.$route;
    },
    instance() {
      return this.$store.state.instance;
    },
    serverPrivilege2() {
      return this.$store.state.user.user.server_privilege2;
    },
    navs() {
      // lists for navigator
      const data = {
        ADCManagement: {
          name: '車輛查詢',
          url: 'ADCManagement',
          privilege: true,
          child: {
            CarList: {
              name: '區間測速資訊',
              url: 'CarList',
              privilege: true,
            },
            CrossLineList: {
              name: '違規停車資訊',
              url: 'CrossLineList',
              privilege: false,
            },
            ShoulderList: {
              name: '行駛路肩資訊',
              url: 'ShoulderList',
              privilege: true,
            },
          },
        },
        ConfirmManagement: {
          name: '認證查詢',
          url: 'ConfirmManagement',
          privilege: true,
          child: {
            CarConfirmList: {
              name: '區間超速',
              url: 'CarConfirmList',
              privilege: true,
            },
            CrossLineConfirmList: {
              name: '違規停車',
              url: 'CrossLineConfirmList',
              privilege: false,
            },
            ShoulderConfirmList: {
              name: '行駛路肩',
              url: 'ShoulderConfirmList',
              privilege: true,
            },
          },
        },
        TicketManagement: {
          name: '開單查詢',
          url: 'TicketManagement',
          privilege: true,
          child: {
            CarTicketList: {
              name: '區間超速',
              url: 'CarTicketList',
              privilege: true,
            },
            CrossLineTicketList: {
              name: '違規停車',
              url: 'CrossLineTicketList',
              privilege: false,
            },
            ShoulderTicketList: {
              name: '行駛路肩',
              url: 'ShoulderTicketList',
              privilege: true,
            },
          },
        },
        ReportExport: {
          name: '紀錄報表',
          url: 'ReportExport',
          privilege: this.reportExportPrivilege,
          child: {
            NTPLogSummary: {
              name: 'NTP資料報表',
              url: 'NTPLogSummary',
              privilege: true,    
            },
            OtherPcLogSummary: {
              name: '獨立主機資料報表',
              url: 'OtherPcLogSummary',
              privilege: true,    
            },
            TimeLogSummary: {
              name: '系統校時報表',
              url: 'TimeLogSummary',
              privilege: false,    
            },
            TimeLogAnalysis: {
              name: '系統校時分析報表',
              url: 'TimeLogAnalysis',
              privilege: false,    
            },
            IpCamTimeLogSummary: {
              name: '攝影機對時報表',
              url: 'IpCamTimeLogSummary',
              privilege: false,    
            },
            TimeSyncSummary: {
              name: '電腦設備同步確認報表',
              url: 'TimeSyncSummary',
              privilege: false,    
            },
            CustomReport: {
              name: '區間速率報表',
              url: 'CustomReport',
              privilege: true,
            },
            CrossLineReport: {
              name: '違規停車報表',
              url: 'CrossLineReport',
              privilege: false,
            },
            ShoulderReport: {
              name: '行駛路肩報表',
              url: 'ShoulderReport',
              privilege: true,
            },
          },
        },
        SystemSettings: {
          name: '系統設定',
          url: 'SystemSettings',
          privilege: false,
          child: {
            UserSettings: {
              name: '使用者設定',
              url: 'UserSettings',
              privilege: true,
            },
            ParaSettings: {
              name: '參數設定',
              url: 'ParaSettings',
              privilege: true,
            },
          },
        },
      };
      // handle privilege here.
      data.SystemSettings.privilege = this.$store.state.user.user.is_superuser;
      //if(data.ReportExport.privilege==false)
      //  data.ReportExport.privilege = this.$store.state.user.user.is_superuser;
      /*
      if(this.$store.state.user.user.username=='B01_1F' ||this.$store.state.user.user.username=='B03_1F') {
        data.TicketManagement.privilege = false  
      }
      if(this.$store.state.user.user.username=='B01_2F' ||this.$store.state.user.user.username=='B03_2F') {
        data.ADCManagement.privilege = false  
      }
      */
      if (this.serverPrivilege2 !== null && this.serverPrivilege2 !== undefined) {
        data.ADCManagement.privilege = this.serverPrivilege2.car_privilege;
        data.ConfirmManagement.privilege = this.serverPrivilege2.confirm_privilege;
        data.TicketManagement.privilege = this.serverPrivilege2.ticket_privilege;
        data.ReportExport.privilege = this.serverPrivilege2.report_output;
      }
      if(this.$store.state.user.user.username=='esttw') {
        data.ReportExport.child.TimeLogAnalysis.privilege = true;  
      }
      return data;
    },
  },
  watch: {
    route(val) {
      this.checkedPath(val);
    },
    fixedLinkCode4SuperUser(val) {
      this.fixedLinkCode4SuperUser = val;
      this.$store.state.user.user.department.fixed_link_code = this.fixedLinkCodeObj[val];
    },
  },
};
</script>

<style lang="sass">
.empty-layout
  display: flex;
  flex-direction: column;
  justify-content: center;
  img
    height: 100px
  p
    text-align: center
    font-size: 20px

.page-active
  background-color: #0056b3
  color: white !important
  &:hover
    background-color: #0056b3


.admin-hero
  height: 300px
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column

.admin-blur
  filter: blur(2px)

.container
  position: relative

.main-container
  border: 1px solid rgba(0,0,0,0.2);
  border-top: none;
  border-bottom: none;
  min-height: calc( 100vh - 71px - 50px);
  background-color: #f9fbe7

.main-footer
  padding: 5px 10px
  background-color: #138496
  color: white

.navbar-admin
  background-color: white
  border: 1px solid rgba(0,0,0,0.2);
  border-top: none;
  border-bottom-color: rgba(0,0,0,0.05)

.detail-layout
  padding: 10px 0
  h6
    color: steelblue
</style>



// WEBPACK FOOTER //
// Admin.vue?71c0c9a8